<template>
	<div class="juniper-breadcrumb">
		<div v-if="field.type == 'switch'" class="form-group">
			<div class="form-check form-switch mb-2 align-items-center d-flex">
				<input class="form-check-input me-2" v-model="field.value" type="checkbox" role="switch" />
				<label class="form-check-label">{{ field.name }}</label>
			</div>
		</div>
		<div v-else-if="field.type == 'textarea'" class="form-group">
			<label>{{ field.name }}</label>
			<textarea class="form-control" rows="7" placeholder="" v-model="field.value" />
		</div>
		<div v-else class="form-group mb-2 ">
			<label for="">{{ field.name }}</label>
			<input type="text" class="form-control" v-model="field.value" />
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
	name: 'FieldInput',
	components: {},
	data() {
		return {}
	},
	props: ['field'],
	computed: {
		...mapState(['authUser', 'tokenJuniper']),
		...mapGetters(['isAuth']),
	},
	created() {},
	methods: {},
}
</script>
